import axiosInstance from "../../utils/axiosConfig";
import { compactParams } from "../../lib/api/params";
import type { IsoDateRange } from "../../lib/adminExport/datePresets";

export const WALLET_EXPORT_PAGE_LIMIT = 100;
export const MAX_WALLET_EXPORT_PAGES = 300;

/** Pages through wallet transactions at a safe limit for CSV export. */
export async function fetchWalletActivitiesForExport(
  range?: IsoDateRange | null
): Promise<any[]> {
  const transactions: any[] = [];
  let totalPages = 1;

  for (let page = 1; page <= totalPages; page++) {
    if (page > MAX_WALLET_EXPORT_PAGES) {
      throw new Error(
        `Export is limited to ${
          MAX_WALLET_EXPORT_PAGES * WALLET_EXPORT_PAGE_LIMIT
        } rows. Narrow your date range.`
      );
    }

    const { data } = await axiosInstance.get<{ data?: unknown }>(
      "api/transactions",
      {
        params: compactParams({
          page,
          limit: WALLET_EXPORT_PAGE_LIMIT,
          excludeTypes: "gift-card-transactions",
          startDate: range?.startDate,
          endDate: range?.endDate,
        }),
      }
    );

    const root = (data?.data ?? {}) as {
      transactions?: any[];
      meta?: { totalPages?: number };
    };
    const batch = Array.isArray(root.transactions) ? root.transactions : [];

    if (page === 1) {
      totalPages = Math.max(1, root.meta?.totalPages ?? 1);
    }

    transactions.push(...batch);
    if (batch.length === 0) break;
  }

  return transactions;
}
